export const ARIA_LABELS_KEYS: Record<string, string> = {
	removeFromFavourites: "game-launcher.remove-from-favourites",
	addToFavourites: "game-launcher.add-to-favourites",
	playForReal: "game-launcher.play-for-real",
};

export const THUMBNAIL_IMAGE_SIZE = {
	default: { width: 196, height: 196 },
	square: {
		/* xxsmall size will be removed when the new components will be used on the right sidebar. Since it’s not part of the design system */
		xxsmall: {
			width: 85,
			height: 85,
		},
		xsmall: {
			width: 100,
			height: 100,
		},
		small: {
			width: 158,
			height: 158,
		},
		medium: {
			width: 196,
			height: 196,
		},
		large: {
			width: 329,
			height: 329,
		},
	},
	landscape: {
		/* xxsmall size will be removed when the new components will be used on the right sidebar. Since it’s not part of the design system */
		xxsmall: {
			width: 85,
			height: 85,
		},
		xsmall: {
			width: 100,
			height: 56,
		},
		small: {
			width: 158,
			height: 89,
		},
		medium: {
			width: 196,
			height: 110,
		},
		large: {
			width: 329,
			height: 184,
		},
	},
	portrait: {
		/* xxsmall size will be removed when the new components will be used on the right sidebar. Since it’s not part of the design system */
		xxsmall: {
			width: 85,
			height: 85,
		},
		xsmall: {
			width: 100,
			height: 113,
		},
		small: {
			width: 158,
			height: 179,
		},
		medium: {
			width: 196,
			height: 221,
		},
		large: {
			width: 329,
			height: 371,
		},
	},
};
